import {React,useEffect,useState} from "react";
// import {Link} from 'react-router-dom'
import {useHistory } from 'react-router-dom'
import { CircularProgressbar,buildStyles } from 'react-circular-progressbar';
// import 'react-circular-progressbar/dist/styles.css';

import './ServiceTop.scss'
import JButton from '../../components/Button/JButton'

const ServiceTop= ({serviceType,step}) => {

    const history = useHistory();
    const [getStep,setStep] = useState("");
    const [getStepValue,setStepValue] = useState(0);
    useEffect( () => {
        if(step===1){
            setStep("۱");
            if(serviceType===1)
                setStepValue(20);
            else
            setStepValue(33.3);
        }
        else if(step===2){
            setStep("۲");
            if(serviceType===1)
                setStepValue(40);
            else
                setStepValue(66.6);
        }
        else if(step===3){
            setStep("۳");
            if(serviceType===1)
                setStepValue(60);
            else
                setStepValue(100);
        }
        else if(step===4){
            setStep("۴");
            setStepValue(80);
        }
        else if(step===5){
            setStep("۵");
            setStepValue(100);
        }
   },[]);

   const handlePrevStep= (e) =>{
    e.preventDefault();
    
        if(serviceType===1){
            if(step===1){
                history.push("/");
            }
            if(step===2){
                history.push("/checkPhone");
            }
            else if(step===3){
                history.push("/serviceShow");
            }
            else if(step===4){
                // history.push("/equipmentShow");
                history.push("/fillInfo");
            }
            // else if(step===5){
            //     history.push("/fillInfo");
            // }
        }
        else{
            if(step===1){
                history.push("/");
            }
            if(step===2){
                history.push("/serviceShow");
            }
            else if(step===3){
                history.push("/fillInfo");
            }
        }
    }

    return (
        <div>
            <div className="steps">
                <div className="stepNumbers">
                    {serviceType === 1 ? ( //####################################### ADSL
                        <>
                        {/* <div className={`step${ step === 5 ? " activeStepADSL" : (step>5 ? " doneStepADSL" : "") }`}>
                            {step == 5 ?
                            <div>
                                <div className="aStep">
                                    <span>۵</span>
                                </div>
                            </div>
                            : <div> <span className={`${ step>5 ? "fa fa-check" : "" }`}>{step>5 ? "" : "۵"}</span></div>}
                            <label>پرداخت</label>
                        </div> */}
                        {/* <div className={`stepLine${ step>4 ? " stepLineDoneADSL" : "" }`}></div> */}
                        <div className={`step${ step === 4 ? " activeStepADSL" : (step>4 ? " doneStepADSL" : "") }`}>
                            {step == 4 ?
                            <div>
                                <div className="aStep">
                                    <span>۴</span>
                                </div>
                            </div>
                            : <div> <span className={`${ step>4 ? "fa fa-check" : "" }`}>{step>4 ? "" : "۴"}</span></div>}
                            {/* <label>تکمیل اطلاعات</label> */}
                            <label>پرداخت</label>
                        </div>
                        <div className={`stepLine${ step>3 ? " stepLineDoneADSL" : "" }`}></div>
                        <div className={`step${ step === 3 ? " activeStepADSL" : (step>3 ? " doneStepADSL" : "") }`}>
                            {step == 3 ?
                            <div>
                                <div className="aStep">
                                    <span>۳</span>
                                </div>
                            </div>
                            : <div> <span className={`${ step>3 ? "fa fa-check" : "" }`}>{step>3 ? "" : "۳"}</span></div>}
                            {/* <label>انتخاب تجهیزات</label> */}
                            <label>تکمیل اطلاعات</label>
                        </div>
                        <div className={`stepLine${ step>2 ? " stepLineDoneADSL" : "" }`}></div>
                        <div className={`step${ step === 2 ? " activeStepADSL" : (step>2 ? " doneStepADSL" : "") }`}>
                            {step === 2 ?
                            <div>
                                <div className="aStep">
                                    <span>۲</span>
                                </div>
                            </div>
                            : <div> <span className={`${ step>2 ? "fa fa-check" : "" }`}>{step>2 ? "" : "۲"}</span></div>}
                            <label>انتخاب سرویس</label>
                        </div>
                        <div className={`stepLine${ step>1 ? " stepLineDoneADSL" : "" }`}></div>
                        <div className={`step${ step === 1 ? " activeStepADSL" : (step>1 ? " doneStepADSL" : "") }`}>
                            {step == 1 ?
                            <div>
                                <div className="aStep">
                                    <span>۱</span>
                                </div>
                            </div>
                            : <div><span className={`${ step>1 ? "fa fa-check" : "" }`}>{step>1 ? "" : "۱"}</span></div>}
                            <label>اعتبار سنجی شماره</label>
                        </div>
                        </>
                    ) : //####################################### LTE
                    (<>
                    <div className={`step${ step === 3 ? (serviceType === 2 ? " activeStepLTE" :  " activeStepGaming") : (step>3 ? (serviceType === 2 ? " doneStepLTE" :  " doneStepGaming") : "" ) }`}>
                        {step == 3 ?
                        <div>
                            <div className="aStep">
                                <span>۳</span>
                            </div>
                        </div>
                        : <div><span className={`${ step>3 ? "fa fa-check" : "" }`}>{step>3 ? "" : "۳"}</span></div>}
                        <label>پرداخت</label>
                    </div>
                    <div className={`stepLine${ step>2 ? (serviceType === 2 ? " stepLineDoneLTE" :  " stepLineDoneGaming") : "" }`}></div>
                    <div className={`step${ step === 2 ? (serviceType === 2 ? " activeStepLTE" :  " activeStepGaming") : (step>2 ? (serviceType === 2 ? " doneStepLTE" :  " doneStepGaming") : "" ) }`}>
                        {step == 2 ?
                        <div>
                            <div className="aStep">
                                <span>۲</span>
                            </div>
                        </div>
                        : <div><span className={`${ step>2 ? "fa fa-check" : "" }`}>{step>2 ? "" : "۲"}</span></div>}
                        <label>تکمیل اطلاعات</label>
                    </div>
                    <div className={`stepLine${ step>1 ? (serviceType === 2 ? " stepLineDoneLTE" :  " stepLineDoneGaming") : "" }`}></div>
                    <div className={`step${ step === 1 ? (serviceType === 2 ? " activeStepLTE" :  " activeStepGaming") : (step>1 ? (serviceType === 2 ? " doneStepLTE" :  " doneStepGaming") : "" ) }`}>
                        {step == 1 ?
                        <div>
                            <div className="aStep">
                                <span>۱</span>
                            </div>
                        </div>
                        : <div><span className={`${ step>1 ? "fa fa-check" : "" }`}>{step>1 ? "" : "۱"}</span></div>}
                        <label>انتخاب سرویس</label>
                    </div>
                    </>)}
                </div>
                <div className="circleStep">
                    <CircularProgressbar value={getStepValue} text={`${ serviceType === 1 ? getStep+'/۴' : (serviceType === 2 ? getStep+'/۳' : getStep+'/۳')}`} styles={buildStyles({
                        textColor: '#323232',
                        trailColor: '#dadada',
                        pathColor: serviceType === 1 ? "#01a4e5" : (serviceType === 2 ? "#fd5d35" : "#0fdbcf"),
                        stroke: '#ff8035',
                    })} />
                </div>
                <div className="stepEmpty"></div>
                <div className={`buyImage ${ serviceType === 1 ? "adsl" : (serviceType === 2 ? "lte" : "gaming")}`}></div>
                <div className="buyTitle">
                    <span>خرید</span>
                    <label className={`${ serviceType === 1 ? "colorADSL" : (serviceType === 2 ? "colorLTE" : "colorGaming")}`}>
                        {serviceType === 1 ? "ADSL" : (serviceType === 2 ? "TD-LTE" : "اینترنت فیبر")}
                    </label>
                </div>
                <div className="circleBack">
                    {/* <Link to="/"> */}
                        {/* <span className="fa fa-arrow-right"></span> */}
                        <JButton  title={""} handleClick={handlePrevStep} leftIcon={"fa fa-arrow-right"} type={"Circle"} noSize={false} width={"52px"} height={"52px"} />
                    {/* </Link> */}
                </div>
            </div>
            <div className={`stepsTitle${ serviceType === 1 && step===2 ? " stepsTitleADSLStep2" : ""}`}>
                {
                    serviceType === 1 ?
                    (
                        step === 1 ?
                        <span>اعتبار سنجی شماره</span>
                        :
                        (
                            step === 2 ?
                            <span>انتخاب سرویس</span>
                            :
                            (
                                step === 3 ?
                                // <span>انتخاب تجهیزات</span>
                                <span>تکمیل اطلاعات </span>
                                :
                                (
                                    step === 4 ?
                                    // <span>تکمیل اطلاعات </span>
                                    <span>پرداخت </span>
                                    :
                                    (
                                        <span>پرداخت </span>
                                    )
                                )
                            )
                        )
                    )
                    :
                    (
                        step === 1 ?
                        <span>انتخاب سرویس</span>
                        :
                        (
                            step === 2 ?
                            <span>تکمیل اطلاعات</span>
                            :
                            (
                                <span>پرداخت </span>
                            )
                        )
                    )
                }
            </div>
        </div>
     );
}

export default ServiceTop;
